import { Dispatch } from 'redux';
import { DirectSalesMediaType, DirectSalesPricingMode } from 'components/common/types/DirectSalesCampaign.types';
import { Store } from 'components/common/types/Store.types';
import { PERMISSION_LABELS } from 'components/pages/PCM/Products/consts';
import { isValueRequired } from 'components/pages/PCM/Products/utils/isValueRequired';
import { resolvePublisherDefaultNonNetworkDirectSalesPricingMode } from 'utils/resolvePublisherDefaultDirectSalesPricingMode';
import { changeNewProductField } from './reducer';
import {
  NewProductCreationPayload,
  ProductFieldName,
  ProductManagementFields,
  SelectionPermission,
} from './reducer.types';

const shouldApplyPublisherDefaultPricingMode = (
  pricingMode: ProductManagementFields['pricingMode'],
  networks: ProductManagementFields['networks'],
): boolean => {
  if (pricingMode?.value === DirectSalesPricingMode.NETWORK) {
    return false;
  }

  if (isValueRequired(networks?.selectionPermission) && networks?.value?.length) {
    return false;
  }

  if (pricingMode?.selectionPermission === SelectionPermission.DISABLED) {
    return false;
  }

  if (pricingMode?.selectionPermission === SelectionPermission.ALL_OPTIONS) {
    return false;
  }

  return true;
};

export const changeNewProductMediaTypeField =
  (payload: NewProductCreationPayload) =>
  (dispatch: Dispatch, getState: () => Store): void => {
    dispatch(changeNewProductField(payload));

    const mediaType = payload.value as DirectSalesMediaType;
    const { newProduct } = getState().productManagement;

    if (!shouldApplyPublisherDefaultPricingMode(newProduct.pricingMode, newProduct.networks)) {
      return;
    }

    const defaultPricingMode = resolvePublisherDefaultNonNetworkDirectSalesPricingMode(
      getState().publisher.campaignConfiguration,
      mediaType,
    );

    dispatch(
      changeNewProductField({
        fieldName: ProductFieldName.PRICING_MODE,
        value: defaultPricingMode,
        selectedPermission: {
          code: SelectionPermission.FIXED_VALUE,
          name: PERMISSION_LABELS[SelectionPermission.FIXED_VALUE],
        },
      }),
    );
  };
